import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  LOGIN_2FA,
  SESSION_USER,
  SESSION_USER_INFO,
  ORG_INFO_SET,
  ORG_INFO_CLEAR,
} from "./types";

const user = JSON.parse(localStorage.getItem("vault_user"));

const initialState = user
  ? { isLoggedIn: true, user, tfaSecret: null, orgInfo: null }
  : { isLoggedIn: false, user: null, tfaSecret: null, orgInfo: null };

export const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return { ...state, isLoggedIn: false };

    case REGISTER_FAIL:
      return { ...state, isLoggedIn: false };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
        qrCodeBase64: payload.qrCodeBase64,
        loginMethod: payload.loginMethod,
      };

    case LOGIN_2FA:
      return {
        ...state,
        isLoggedIn: false,
        tfaSecret: payload.tfaSecret,
        loginMethod: payload.loginMethod,
        qrCodeBase64: payload.qrCodeBase64,
        username: payload.username,
      };

    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        tfaSecret: null,
        qrCodeBase64: null,
        loginMethod: null,
        username: null,
        orgInfo: null,
      };

    case SESSION_USER:
      return {
        ...state,
        isLoggedIn: true,
        sessUser: payload.sessUser,
        sessAvatar: payload.sessAvatar,
      };

    case SESSION_USER_INFO:
      return {
        ...state,
        isLoggedIn: true,
        sessUserInfo: payload.sessUserInfo,
      };

    case ORG_INFO_SET:
      return {
        ...state,
        orgInfo: payload?.orgInfo ?? null,
      };

    case ORG_INFO_CLEAR:
      return {
        ...state,
        orgInfo: null,
      };

    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        qrCodeBase64: null,
        tfaSecret: null,
        loginMethod: null,
        username: null,
        orgInfo: null,
      };

    default:
      return state;
  }
};
